export default __webpack_public_path__ + "static/media/1842.ae301cb9.png";